export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = useUserStore();

  if (userStore.token && userStore.user) {
    if (userStore.user.role === "user") {
      return await navigateTo("/games");
    }
  }
});
